import { Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from "@angular/core";
import { Order } from "../../../../objects/orders/order";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderStatus } from "../../../../objects/orders/orderStatus";
import { ExtraData } from "../../../../objects/extraData/extraData";
import { CalculatorComponent } from "../../../calculator/calculator.component";
import { CalculatorHelper } from "../../../../common/helpers/calculatorHelper";
import { OrderService } from "../../../../services/orderService";

@Component({
    selector: "order-details",
    templateUrl: "./orderDetails.component.html",
    moduleId: module.id.toString()
})

export class OrderDetails implements OnInit {

    @ViewChild('calculator')
    public calculator: CalculatorComponent;

    public order: Order;

    public query: string = "";

    public agentId?: number = null;
    public customerId?: number = null;

    public orderStatus = OrderStatus;
    public extraData: ExtraData = new ExtraData();

    public isMobile: boolean = false;

    public tabNumber: number;

    constructor(private route: ActivatedRoute, private router: Router) {
    }

    @HostListener('window:resize', ['$event'])
    public checkIfMobile(event: any): void {
        if (event.target.innerWidth <= 768)
            this.isMobile = true;
        else
            this.isMobile = false;
    }


    public ngOnInit(): void {
        this.order = this.route.snapshot.data.order.Data;

        let extraData: Array<ExtraData>;

        if (this.route.snapshot.data.extraData)
            extraData = this.route.snapshot.data.extraData.Data;

        if (extraData && extraData.length > 0) {
            let extr = extraData.find(x => x.Name == 'marketing text');

            if (extr)
                this.extraData = extr;
        }

        this.tabNumber = this.order.Status;

        // if (this.order.Status == OrderStatus.Calculated)
        //     this.tabNumber = OrderStatus.Quoted;

        if (this.order.Status >= OrderStatus.BorderCrossed)
            this.tabNumber = OrderStatus.CustomReleased;

        if (window.screen.width <= 768)
            this.isMobile = true;

        this.route.params.subscribe(params => {
            let query = params['query'];
            let agentId = params['agentid'];
            let customerId = params['customerid'];

            if (query)
                this.query = query;

            if (agentId)
                this.agentId = agentId;

            if (customerId)
                this.customerId = customerId;
        });
    }

    public search(): void {
        this.router.navigate([`management/order`, { query: this.query }]);
    }


    public getPageHeader(status: OrderStatus): string {
        switch (status) {
            case 0:
                return 'Calculated';
            case 1:
                return 'Quoted';
            case 2:
                return 'Paid';
            case 3:
                return 'Preparing Documents';
            case 4:
                return 'Sent to Customs';
            case 5:
                return 'Customs Released';
            case 6:
                return 'Border Crossed';
            case 7:
                return 'Case Closed';
            default:
                return '';
        }
    }

    public getIconClass(status: OrderStatus): string {
        if (this.order.Status == OrderStatus.Calculated && status == OrderStatus.Quoted && this.tabNumber == 0)
            return "in-progress";

        if (this.isMobile) {
            if (this.tabNumber == 0 && status == OrderStatus.Calculated)
                return "in-progress";
            else if (status == this.tabNumber + 1)
                return "in-progress";

            if (this.tabNumber == OrderStatus.Paid) {
                if (status == this.tabNumber + 2)
                    return "in-progress";
            }

            if (status <= this.order.Status)
                return "passed";

            return "non-clickable";
        }

        if (status <= this.order.Status)
            return "passed";

        if (status == this.order.Status + 1)
            return "in-progress";

        if (this.order.Status == OrderStatus.Paid) {
            if (status == this.order.Status + 2)
                return "in-progress";
        }

        return "non-clickable";
    }

    public setTab(num: number): void {
        if (num > this.order.Status || this.isMobile == false)
            return;

        this.tabNumber = num;

        document.getElementById('mainPanel').scrollTop = 0;

        this.calculator.setOrderDataTab(num);
    }
}



// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderDetails/orderDetails.component.ts